import PartialOfferPage from "./PartialOfferPage";

export default PartialOfferPage;